<template>
  <div :class="styleWrapperClass || `checkbox-group`">
    <div v-for="option in options" :key="option.id" class="checkbox" :class="styleClass">
      <input :id="option.label" :class="{error : validationError}" :value="option.value" :disabled="disabled" type="checkbox" v-model="picked">
      <label class="subhead" :for="option.label">{{option.label}}</label>
    </div>
  </div>
</template>

<script>
import * as validationLib from '@/lib/validation/'
const {
  helpers,
  validate
} = validationLib
export default {
  name: 'adx-multiple-checkbox',
  props: {
    label: {
      required: false
    },
    value: {
      required: false
    },
    grup: {
      required: false
    },
    options: {
      required: false
    },
    error: {
      required: false
    },
    validation: {
      required: false
    },
    styleClass: {
      required: false
    },
    styleWrapperClass: {
      required: false
    },
    disabled: {
      required: false,
      default: false
    },
    isInitial: {
      required: false
    }
  },
  data() {
    return {
      initial: true,
      picked: [],
      valid: undefined,
      message: undefined
    }
  },
  mounted() {
    if(this.value) this.picked = this.value
    if (!this.validation) {
      this.$emit(`update:isInitial`, false)
    }
  },
  methods: {
    validateInput(value) {
      if (this.validation) {
        const { valid, message } = validate(this.validation, value, this.label)
        if(valid) {
          this.$emit(`update:value`, value)
          this.$emit(`update:error`, false)
        } else {
          this.$emit(`update:value`, ``)
          this.$emit(`update:error`, !valid)
        }
        this.valid = valid
        this.message = message
      } else {
        this.$emit(`update:value`, value)
        this.$emit(`update:error`, false)
      }
      this.$emit(`update:isInitial`, false)
    }
  },
  watch: {
    picked() {
      this.validateInput(this.picked)
    },
    value() {
      this.picked = this.value
    }
  },
  computed: {
    validationError: function () {
      if (this.error) return this.error
      return this.valid === undefined ? false : !this.valid
    }
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>